import useAuthStore from "stores/AuthStore/AuthStore";
import { PARTNER_ONBOARDING_DRAFT_KEY } from "commons/constants";
import { logoutPortal } from "pages/Auth/login.service";

export async function signOutPortal() {
  // Best-effort server-side token revocation; proceed even if it fails
  try {
    await logoutPortal();
  } catch {
    /* ignore — network errors must never block the client-side logout */
  }

  useAuthStore.getState().clearUserData();

  try {
    sessionStorage.removeItem(PARTNER_ONBOARDING_DRAFT_KEY);
  } catch {
    /* ignore */
  }

  window.location.href = "/login";
}
